<template>
  <div
    class="grow space-y-2"
    data-test-id="review-snapshot-rating-breakdown"
  >
    <vf-tooltip
      v-for="{ rating, reviewCount } in ratingHistogram"
      :key="rating"
      class-trigger="grow"
      placement="top"
      @click="$emit('filter-by-rating', rating)"
    >
      <template #trigger>
        <div class="w-full flex items-center gap-2 rounded-md">
          <span class="shrink-0 text-xs">
            {{ rating }}
          </span>
          <vf-progress-bar class="w-full rounded-xl" :max="reviewsCount" :value="reviewCount" />
        </div>
      </template>
      {{ replaceAll($t.showOnlyStarReviews, { stars: rating }) }}
    </vf-tooltip>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  ratingHistogram: Array<{ rating: number, reviewCount: number }>
  reviewsCount: number
}>()

defineEmits<{
  'filter-by-rating': [rating: number]
}>()
</script>
